module.exports = __webpack_public_path__ + "static/media/Collection_2.a868ed9d.jpg";